import { transformComponent } from '@/formily/__builtins__/shared'
import { connect, mapProps, mapReadPretty, h } from '@formily/vue'
import { defineComponent } from 'vue-demi'
import PointInputNumber from './Input.vue'
import { Input as RichInputNumber } from '@didi/rich-ui'
import { InputPreviewText } from '@/formily/src/PreviewText'
import './style.scss'
/* eslint-disable vue/require-default-prop, vue/require-prop-types */
const RichInputNumberInner = defineComponent({
  props: {
    value: {},
    accuracy: {},
    appendValue: {},
  },
  setup(props, { slots, attrs, listeners }) {
    if (attrs.point) {
      return () =>
        h(
          PointInputNumber,
          {
            props,
            attrs: {
              ...attrs,
            },
            on: {
              ...listeners,
            },
          },
          {
            default: () => slots.default && slots.default(),
            append: slots.append ? () => slots.append() : '',
          },
        )
    } else {
      return () =>
        h(
          RichInputNumber,
          {
            props,
            attrs: {
              ...attrs,
            },
            on: {
              ...listeners,
            },
          },
          {
            default: () => slots.default && slots.default(),
            append: slots.append ? () => slots.append() : '',
          },
        )
    }
  },
})

const AmountInputNumber = transformComponent(RichInputNumberInner, {
  change: 'input',
})

export const InputNumber = connect(
  AmountInputNumber,
  mapProps({ readOnly: 'readonly' }, props => {
    return {
      // type: 'number',
      class: 'rich-input-wrapper custom-amount-input',
    }
  }),
  mapReadPretty(InputPreviewText),
)

export default InputNumber
